export default "assets/images/small_logo-3d768f8b.svg";